import { InputProps as StandardInputProps } from '@mui/material/Input/Input';
import BigNumber from 'bignumber.js';

import { parseFormattedIntValue } from './parseFormattedIntValue';

export function handleChangeInputType(
  type: string,
  onChange: StandardInputProps['onChange'],
): StandardInputProps['onChange'] {
  return event => {
    if (!onChange) {
      return;
    }

    const { value } = event.target;
    const lowerCaseType = type.toLowerCase();
    const isInteger = lowerCaseType.indexOf('int') > -1;

    const isValid = (() => {
      if (lowerCaseType.indexOf('[]') > -1) {
        return true;
      }

      if (isInteger) {
        const parsedValue = parseFormattedIntValue(value);

        const isInteger = new BigNumber(+parsedValue).isInteger();
        if (!isInteger) {
          return false;
        }

        const isHexValue = String(parsedValue).startsWith('0x');
        if (isHexValue) {
          return false;
        }

        const isExponential =
          new BigNumber(+parsedValue).toExponential() ===
          parsedValue.toString();
        if (isExponential) {
          return false;
        }
      }

      return true;
    })();

    if (!isValid) {
      return;
    }

    if (isInteger) {
      onChange({
        ...event,
        target: { ...event.target, value: parseFormattedIntValue(value) },
      });
    } else {
      onChange(event);
    }
  };
}
